export enum SiteSection {
  INSTITUTIONAL_B2C,
  INSTITUTIONAL_B2B,
  ABOUT,
  CONTACT,
  REGISTER_CANDIDATE,
  TUTORIALS
}
